module.exports = __webpack_public_path__ + "static/media/999331.a0598c09.png";